<template>
  <div>
    <div class="simpleStorageServiceResource-title">
      <div>{{ $t("RAM.AWS.StorageBin.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:simpleStorageServiceResource:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:simpleStorageServiceResource:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="simpleStorageServiceResource-top">
      <simple-storage-service-resource-search
        ref="simpleStorageServiceResourceSearchChild"
      ></simple-storage-service-resource-search>
    </div>
    <table-simple-storage-service-resource></table-simple-storage-service-resource>
  </div>
</template>

<script>
import SimpleStorageServiceResourceSearch from "../s3/SimpleStorageServiceResourceSearch";
import TableSimpleStorageServiceResource from "../s3/TableSimpleStorageServiceResource";

export default {
  name: "SimpleStorageServiceResource",
  components: {
    SimpleStorageServiceResourceSearch,
    TableSimpleStorageServiceResource
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      bucketNameSearchIDVal: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.simpleStorageServiceResourceSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 5,
          accountType: 0
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.bucketNameSearchIDVal = this.$refs.simpleStorageServiceResourceSearchChild.bucketName;
      this.companyId = this.$refs.simpleStorageServiceResourceSearchChild.companyId;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSBucket({
          name: this.bucketNameSearchIDVal,
          companyId: this.companyId,
          accountType: 0
        })
        .then(res => {
          let fileName = "存储桶.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.simpleStorageServiceResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.simpleStorageServiceResource-title > div:nth-child(1) {
  float: left;
}
.simpleStorageServiceResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.simpleStorageServiceResource-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/s3/SimpleStorageServiceResource.vue